import React from "react";
import "lightbox2/dist/css/lightbox.css";
import "lightbox2/dist/js/lightbox-plus-jquery";
import "./../Styles/style.css";
/* eslint-disable */
const images = require.context("./../images", true);
const imageList = images.keys().map((image) => images(image));

export const GalleryPage = () => {
  return (
    <div className="container" style={{ padding: "20px" }}>
      <h1 className="header-style"> Gallery</h1>
      <div className="row g-3">
        {imageList.map((image, index) => {
          return (
            <div
              key={index}
              className="item col-lg-3 col-md-4 col-6"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <a href={image} data-lightbox="default-gallery">
                <img
                  src={image}
                  className="img-thumbnail thumbnail-style"
                  alt={`Gallery item ${index + 1}`}
                  style={{
                    borderRadius: "10px",
                    maxHeight: "200px",
                    objectFit: "cover",
                  }}
                />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
